import React from 'react';
import {CartItemDataHook} from '../../CartItem';
import {useControllerProps} from '../../../../../../domain/controllers/ControllerContext';
import {classes} from '../../CartItem.st.css';
import {useTranslation} from '@wix/yoshi-flow-editor';
import {Delete} from '@wix/wix-ui-icons-common/on-stage';
import {LineItemModel} from '../../../../../../domain/models/LineItems/LineItem.model';

export interface RemoveProps {
  lineItem: LineItemModel;
  onRemoveItem?: () => void;
}

export const Remove = ({lineItem, onRemoveItem}: RemoveProps) => {
  const {t} = useTranslation();
  const {removeItemFromCart} = useControllerProps().cartStore;
  const handleRemoveItem = () => {
    removeItemFromCart(lineItem);
    onRemoveItem?.();
  };

  return (
    <button
      className={classes.remove}
      type="button"
      aria-label={t('cart.sr_remove_item_from_cart', {item_name: lineItem.name})}
      onClick={handleRemoveItem}
      data-hook={CartItemDataHook.Remove}>
      <Delete />
    </button>
  );
};
